function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 2.119C0 1.252.752.5 1.619.5h9.946c.925 0 1.619.752 1.619 1.619v13.646c0 .925-.752 1.62-1.62 1.62H1.62A1.616 1.616 0 010 15.764V2.12z",
  fill: "#747474"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.847 2.466h1.966c.231 0 .405.174.405.405a.395.395 0 01-.405.405H8.847a.395.395 0 01-.405-.405c0-.231.174-.405.405-.405zM2.37 14.667h1.967c.231 0 .404.173.404.404a.395.395 0 01-.404.405H2.37a.395.395 0 01-.405-.405c0-.231.173-.404.405-.404z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.466 9.963h4.8c.637 0 1.118.516 1.118 1.119v4.799c0 .637-.516 1.119-1.119 1.119h-4.799c-.637 0-1.12-.516-1.12-1.12v-4.798c0-.592.529-1.12 1.12-1.12z",
  fill: "#747474",
  stroke: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.86 15.014l-.751-.752c-.058-.058-.058-.058-.116-.058h-.115a1.57 1.57 0 00.347-.983c0-.867-.694-1.619-1.62-1.619-.867 0-1.619.694-1.619 1.619 0 .867.694 1.62 1.62 1.62.346 0 .693-.117.982-.348v.116c0 .058 0 .115.058.115l.752.752c.058.058.174.058.29 0l.23-.231c.058 0 .058-.174-.057-.231zm-2.255-.81c-.52 0-.982-.463-.982-.983s.462-.983.982-.983.983.463.983.983-.462.983-.982.983z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.772 6.167c.116-.116.173-.29.173-.52 0-.232-.057-.348-.173-.521-.116-.116-.29-.174-.52-.174H3.527c-.231 0-.347.058-.52.174a.933.933 0 00-.174.52c0 .232.058.347.174.52.115.116.289.174.52.174H5.61v6.534c0 .231.058.405.231.52.116.116.347.232.52.232.174 0 .405-.058.52-.231.117-.116.232-.347.232-.52V6.397h2.14c.23 0 .404-.058.52-.231z",
  fill: "#fff"
});

function SvgTender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgTender;